//@import dependencies
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../companyModule.scss'
import { MdClear } from 'react-icons/md'

// @ADD Component types
interface ICompanyModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  viewer: boolean
}

const CompanyModuleLayout: React.FC<ICompanyModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const formHook = useForm()
  const [logo, setLogo] = useState<string | undefined>(undefined)
  const [logoClear, setLogoClear] = useState<boolean>(false)
  const [background, setBackground] = useState<string | undefined>(undefined)
  const [backgroundClear, setBackgroundClear] = useState<boolean>(false)

  const clearInputFile = (field: 'logo' | 'background') => {
    if (field === 'logo') {
      setLogo(undefined);
      setLogoClear(true)
      formHook.setValue('logoFile', null)
    } else if (field === 'background') {
      setBackground(undefined);
      setBackgroundClear(true)
      formHook.setValue('backgroundFile', null)
    }
  }

  const handleChangeInputFile = (field: 'logo' | 'background', files: any[]) => {
    const hasFile = files.length === 0 ? false : true
    if (!hasFile) {
      clearInputFile(field)
    } else {
      if (field === 'logo') {
        setLogoClear(false)
      } else if (field === 'background') {
        setBackgroundClear(false)
      }
    }
  }

  useEffect(() => {
    if (props?.editData?.details?.background) {
      setBackground(props?.editData?.details?.background)
    }
    if (props?.editData?.details?.logo) {
      setLogo(props?.editData?.details?.logo)
    }
  }, [props.editData])

  return(
    <div className='company-form'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.companies.general_information")}</h3>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div className='form-group '>
                <label htmlFor='name'>{t('labels.companies.name')}</label>
                {formHook.errors.name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='name'
                  name='name'
                  className={`form-control ${formHook.errors.name && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.name}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className='form-group '>
                <label htmlFor='description'>{t('labels.companies.description')}</label>
                {formHook.errors.description && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='description'
                  name='description'
                  className={`form-control ${formHook.errors.description && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.description}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className='form-group'>
                    <label htmlFor='logoFile'>{t('labels.companies.logo')}</label>
                    {formHook.errors.logoFile && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='logoFile'
                      name='logoFile'
                      className='form-control-file'
                      type='file'
                      onChange={(event: any) => handleChangeInputFile('logo', event.target.files)}
                      ref={formHook.register({ required: false })}
                    />
                    <input type="hidden" name="logoFileClear" value={logoClear.toString()} ref={formHook.register({ required: false })} />
                    {formHook.errors.logoFile && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
                {logo && (
                  <div className="col-md-6">
                    <div className="form-group">
                        <div className="logo-container">
                          <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement={`top`}
                            overlay={
                              <Tooltip id='toolip-circle'>
                                Eliminar imagen
                              </Tooltip>
                            }>
                            <button
                              className='btn btn-primary clear-input-file'
                              onClick={() => clearInputFile('logo')}
                              type="button"
                            >
                              <MdClear />
                            </button>
                          </OverlayTrigger>
                          <img src={logo} alt=""/>
                        </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <div className='form-group'>
                    <label htmlFor='backgroundFile'>{t('labels.companies.background')}</label>
                    {formHook.errors.backgroundFile && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='backgroundFile'
                      name='backgroundFile'
                      className='form-control-file'
                      type='file'
                      ref={formHook.register({ required: false })}
                    />
                    <input type="hidden" name="backgroundFileClear" value={backgroundClear.toString()} ref={formHook.register({ required: false })} />
                    {formHook.errors.backgroundFile && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
                {background && (
                  <div className="col-md-6">
                    <div className="form-group">
                        <div className="background-container">
                          <OverlayTrigger
                            trigger={['hover', 'focus']}
                            placement={`top`}
                            overlay={
                              <Tooltip id='toolip-circle'>
                                Eliminar imagen
                              </Tooltip>
                            }>
                            <button
                              className='btn btn-primary clear-input-file'
                              onClick={() => clearInputFile('background')}
                              type="button"
                            >
                              <MdClear />
                            </button>
                          </OverlayTrigger>
                          <img src={background} alt=""/>
                        </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit'>
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}

        </form>
      </fieldset>
    </div>
  )
}

export default CompanyModuleLayout
